import { BabyCarriageIcon } from './BabyCarriageIcon';

/**
 * author: Google
 * id FA711E97-6083-45AA-9C92-FCCDABC57D37
 * name baby-carriage
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/baby-carriage.svg
 * tags
 * - People / Family 
 */
export const BuggyIcon = BabyCarriageIcon;
export default BuggyIcon